module.exports = __webpack_public_path__ + "static/media/showers-1.5dd65a11.jpg";